export const messages = {
  title: 'Vouchered Game List',
  configurePageTitle: 'Configure Game',
  updatePageTitle: 'Update Game',
  subtitle: 'Create a game to engage with members within Experience',
  listPageTitle: 'Vouchered Game List',
};
